import React, { useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Calendar, Bus, Users, MapPin, Bell, LogOut, TicketCheck, Sparkles, Menu, X, MessageSquareQuote, Settings as SettingsIcon, Globe } from "lucide-react";
import { clearSession } from "../lib/api";

export default function AdminLayout() {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const items = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/admin/bookings", label: "Bookings", icon: TicketCheck },
    { to: "/admin/leads", label: "Leads", icon: MessageSquareQuote },
    { to: "/admin/calendar", label: "Calendar", icon: Calendar },
    { to: "/admin/vehicles", label: "Vehicles", icon: Bus },
    { to: "/admin/drivers", label: "Drivers", icon: Users },
    { to: "/admin/routes", label: "Routes", icon: MapPin },
    { to: "/admin/tours", label: "Tours", icon: Sparkles },
    { to: "/admin/slogans", label: "Slogans", icon: MessageSquareQuote },
    { to: "/admin/seo", label: "SEO Pages", icon: Globe },
    { to: "/admin/notifications", label: "Notifications", icon: Bell },
    { to: "/admin/settings", label: "Settings", icon: SettingsIcon },
  ];
  const closeAndGo = () => setOpen(false);

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Mobile top bar */}
      <div className="lg:hidden sticky top-0 z-30 flex items-center justify-between bg-[#1e1b4b] text-white px-4 h-14 shadow">
        <Link to="/admin" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-md bg-[#ea580c] grid place-items-center font-black font-display text-sm">S</div>
          <div className="font-display font-bold">Admin</div>
        </Link>
        <button onClick={()=>setOpen(!open)} data-testid="admin-menu-toggle" className="p-2">{open ? <X /> : <Menu />}</button>
      </div>

      {/* Overlay for mobile */}
      {open && <div onClick={()=>setOpen(false)} className="lg:hidden fixed inset-0 bg-black/40 z-30" />}

      {/* Sidebar */}
      <aside className={`fixed inset-y-0 left-0 z-40 w-64 bg-[#1e1b4b] text-white flex flex-col transform transition-transform duration-200 ${open?"translate-x-0":"-translate-x-full"} lg:translate-x-0`}>
        <Link to="/admin" onClick={closeAndGo} className="flex items-center gap-2 p-5 border-b border-white/10">
          <div className="w-9 h-9 rounded-lg bg-[#ea580c] grid place-items-center font-black font-display">S</div>
          <div>
            <div className="font-display font-bold">Shruti Tours</div>
            <div className="text-xs text-white/60">Admin Panel</div>
          </div>
        </Link>
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
          {items.map(it => (
            <NavLink key={it.to} to={it.to} end={it.end} onClick={closeAndGo}
              data-testid={`admin-nav-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({isActive}) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? "bg-[#ea580c] text-white" : "text-white/80 hover:bg-white/10"}`}>
              <it.icon className="w-4 h-4" />{it.label}
            </NavLink>
          ))}
        </nav>
        <button onClick={()=>{clearSession(); nav("/admin/login");}} className="m-3 flex items-center gap-2 px-3 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-sm" data-testid="admin-logout">
          <LogOut className="w-4 h-4" /> Logout
        </button>
      </aside>

      <main className="lg:ml-64 p-4 md:p-6 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
